import React, { useEffect, useState } from "react";
import style from "./Adminchats.module.css";
import { MdAddComment } from "react-icons/md";
import Chatscard from "./Chatscard";
import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import { db } from "../../firebase/config";
const Adminchats = (props) => {
  const [chats, setChats] = useState([]);
  const [chatspermission, setChatspermission] = useState([]);
  const [chatsid, setChatsid] = useState([]);
  const fetchchats = async () => {
    const querySnapshot = await getDocs(collection(db, "roomuser"));
    const demo = [];
    querySnapshot?.forEach((doc) => {
      demo.push(doc.data());
      setChats([...chats, ...demo]);
    });
  };
  useEffect(() => {
    fetchchats();
    const chatsidfunction = async () => {
      const demo = [];
      const querySnapshot = await getDocs(collection(db, "messages"));
      querySnapshot.forEach((doc) => {
        doc.data()?.message?.forEach((everymessage) => {
          if (everymessage.status === "pending") {
            demo.push(everymessage.chatid);
          }
        });
      });
      setChatsid([...new Set(demo)]);
    };
    {
      props.permission && chatsidfunction();
    }
  }, []);
  useEffect(() => {
    const getchatspermission = async () => {
      const demo = [];
      // chatsid.forEach(async (chatid)=>{
      for (const id of chatsid) {
        const q = query(collection(db, "roomuser"), where("uid", "==", id));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          demo.push(doc.data());
        });
      }
      // })
      setChatspermission([...chatspermission, ...demo]);
    };
    {
      props.permission && getchatspermission();
    }
  }, [chatsid]);
  const deletechat = async (id) => {
    await deleteDoc(doc(db, "messages", id));
    await deleteDoc(doc(db, "roomuser", id));
    setChats(chats.filter((e) => e.uid !== id));
  };
  const finishchat = async (id) => {
    const chatvalue = chats.filter((e) => e.uid === id);
    await setDoc(doc(db, "finishedchats", id), chatvalue[0]);
    await deleteDoc(doc(db, "roomuser", id));
    setChats(chats.filter((e) => e.uid !== id));
  };
  return (
    <div className={style.container}>
      <div className={style.chatsnav}>
        {props.permission && <p>جميع الشاتات التي تحتوي علي رسائل معلقه </p>}
        {!props.permission && <p>جميع الشاتات المتاحه </p>}
        <MdAddComment size={48} />
      </div>
      <div className={style.allchats}>
        {!props.permission &&
          chats.map((chat) => {
            return (
              <Chatscard
                finishchat={finishchat}
                deletechat={deletechat}
                permission={props.permission}
                support={props.support}
                key={chat.uid}
                chat={chat}
                finish={false}
              />
            );
          })}
        {props.permission &&
          chatspermission.map((chat) => {
            return (
              <Chatscard
                finishchat={finishchat}
                deletechat={deletechat}
                permission={props.permission}
                support={props.support}
                key={chat.uid}
                chat={chat}
                finish={false}
              />
            );
          })}
      </div>
    </div>
  );
};
export default Adminchats;
